module.exports = __webpack_public_path__ + "img/icon-sb-customize-this-set-boutique-48x48.0d0a283.svg";